import { render, staticRenderFns } from "./trainDetailNeiBu.vue?vue&type=template&id=2d664d6a"
import script from "./trainDetailNeiBu.vue?vue&type=script&lang=js"
export * from "./trainDetailNeiBu.vue?vue&type=script&lang=js"
import style0 from "./trainDetailNeiBu.vue?vue&type=style&index=0&id=2d664d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports